module.exports = __webpack_public_path__ + "media/images/group2-2c40a5058370178e2fa51630622c574d.svg";